<template>
  <div
    v-if="message"
    :class="customclass"
  >
    <span v-html="message"></span>
    <button
      type="button"
      class="close"
      aria-label="Close"
      @click="close"
    >
      <i
        class="fas fa-times"
        title="Close"
        aria-hidden="true"
      ></i>
    </button>
  </div>
</template>

<script>
export default {
  name: 'dt-message',
  props: {
    value: String,
    timeout: {
      type: Number,
      default: 0
    },
    customclass: String
  },
  computed: {
    message: {
      get() {
        let msg = this.value
        if (this.value !== '' && this.timeout !== 0) {
          this.runTimer()
        }
        return msg
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  },
  methods: {
    runTimer() {
      let $this = this
      setTimeout(function() {
        $this.message = ''
      }, this.timeout)
    },
    close() {
      this.message = ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/utilities/form/dt-message.vue